/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import {getHost, reduceParams, parseParams, querystring} from '@ywfe/utils';



  const {basePath = '', loginPath = ''} = getHost("PROAUTH", "446")



  
    
      export interface API48399Item {
        
      /** 任务idY */
      id?: number;
        
      /** 任务标题 */
      taskTitle?: string;
        
      /** <pre>,任务状态(1:未开始;2:进行中;3:已关闭;5:已完成),,详见枚举定义：com.ywwl.foundation.teamwork.client.enums.TaskStatusEnum,<pre> */
      taskStatus?: number;
        
      /** 任务执行人id */
      executorId?: string;
        
      /** 任务执行人姓名 */
      executorName?: string;
        
      /** <pre>,执行人的任务处理状态(1:未开始;2:进行中;3:已关闭;5:已完成),详见枚举定义：com.ywwl.foundation.teamwork.client.enums.TaskStatusEnum,<pre> */
      executorTaskStatus?: number;
        
      /** 任务创建类型(1:人工创建,2:系统创建),详见TaskCreateTypeEnum */
      taskCreateType?: number;
        
      /** 任务创建类型描述 */
      createTypeDesc?: string;
        
      /** 业务域(1:自定义,2:直播,3:商家,4:内控,5:大数据,6:粉丝，默认自定义),详见BizDomainEnum */
      bizDomain?: number;
        
      /** 任务执行者姓名列表 ,String */
      executorNameList?: string[];
        
      /** 任务创建人发起人 */
      creator?: string;
        
      /** 任务发起者姓名 */
      creatorName?: string;
        
      /** 用户状态,,@seecom.ywwl.foundation.teamwork.client.enums.UserStatusEnum */
      creatorStatus?: string;
        
      /** 任务发起者头像 */
      creatorLogo?: string;
        
      /** 计划开始时间yyyy-MM-ddHH:mm */
      startTime?: any;
        
      /** 计划完成时间yyyy-MM-ddHH:mm */
      endTime?: any;
        
      /** 优先级(1:较低,2:普通,3:紧急,4:非常紧急),详见TaskPriorityEnum */
      taskPriority?: number;
        
      /** 优先级描述 */
      taskPriorityDesc?: string;
        
      /** 逾期标签(1:正常,2:逾期),详见OverdueEnum,,@seecom.ywwl.foundation.teamwork.client.enums.OverdueEnum */
      overdueTag?: number;
        
      /** 逾期标签显示文本 */
      overdueTagName?: string;
        
      /** 任务评级(1~5) */
      evaluateLevel?: number;
        
      /** 需要获取用户信息（如头像）的用户Id ,WorkTaskUserDTO */
      users?: API48399Item[];
        
      /** 任务权限归属类型(1:创建者,2:主播,3:项目) */
      ownerType?: number;
        
      /** 任务状态(1:未开始;2:进行中;3:已关闭;5:已完成) */
      taskStatusName?: string;
        
      /** 任务权限归属类型,,@seecom.ywwl.foundation.teamwork.client.enums.OwnerTypeEnum */
      ownerTypeName?: string;
        
      /** 优先级(1:较低,2:普通,3:紧急,4:非常紧急),详见TaskPriorityEnum */
      taskPriorityName?: string;
        
      /** 任务创建类型(1:人工创建,2:系统创建),详见TaskCreateTypeEnum */
      createTypeName?: string;
        
      /** 业务域(1:自定义,2:直播,3:商家,4:内控,5:大数据,6:粉丝，默认自定义),详见BizDomainEnum */
      bizDomainName?: string;
        
      /** 权限列表[read,edit,process] ,String */
      permissionList?: string[];
        
      /** 执行人列表 ,WorkTaskExecutorDTO */
      executorList?: API48399Item[];
        
      };
    
  



  export interface API48399Req {
  
      /** 任务查询类型(1:我执行的任务,2:我发起的任务,3:抄送我的任务,4:待我处理的任务),,@seeTaskQueryTypeEnum */
      queryType?: string;
    
      /** 任务标题 */
      taskTitle?: string;
    
      /** 优先级(1:较低,2:普通,3:紧急,4:非常紧急),详见TaskPriorityEnum */
      taskPriority?: string;
    
      /** <pre>,任务状态(1:未开始;2:进行中;3:已关闭;5:已完成),,详见枚举定义：com.ywwl.foundation.teamwork.client.enums.TaskStatusEnum,<pre> */
      taskStatus?: string;
    
      /** 任务执行人id */
      executorId?: string;
    
      /** 抄送人id */
      taskCCId?: string;
    
      /** 任务发起人Id */
      creator?: string;
    
      /** 开始时间yyyy-MM-ddHH:mm:ss */
      startTime?: string;
    
      /** 完成时间yyyy-MM-ddHH:mm:ss */
      endTime?: string;
    
      /** 任务执行人姓名 */
      executorName?: string;
    
      /** 排序字段 */
      orderFiled?: string;
    
      /** 排序类型(0:降序,1:升序) */
      orderType?: string;
    
      /** 是否查询用户信息、比如用户头像、花名等.1=是，0=否。默认0 */
      queryUser?: string;
    
      /** 任务发起者姓名 */
      creatorName?: string;
    
      /** 入口1=home首页默认为更多列表 */
      entranceType?: string;
    
      /**  */
      pageSize?: string;
    
      /**  */
      pageIndex?: string;
    
      /**  */
      rowId?: string;
    
      /**  */
      jumpType?: string;
    
      /**  */
      searchCount?: string;
    
      /**  */
      orderObjects?: string;
    
  };



  export interface API48399Res {
    /** T  */
    list?: API48399Item[];
    /**   */
    totalNumber?: any;
    /**   */
    totalPage?: any;
    /**   */
    rowId?: string;
    /**   */
    hasNext?: boolean;
    /**   */
    pageSize?: any;
    /**   */
    pageIndex?: any;
    
  };


// 48399 分页查询任务 抄送我的

export const useGetAPI48399 = () => {
  let isMount = true;
  const [isAPI48399Loading, setIsAPI48399Loading] = useState(false);
  const [dataAPI48399, setDataAPI48399] = useState<API48399Res>({} as API48399Res);
  const fetchAPI48399Data = async (inputs: API48399Req, config?: YWRequestConfig): Promise<API48399Res> => {
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API48399Req>) || {}) as API48399Req;
    
    if ( isMount ) {
      setIsAPI48399Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API48399Res>(`${basePath}/team-work/workTask/pageQueryWorkTaskCcByme?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI48399(res || {} as API48399Res);
        setIsAPI48399Loading(false);
      }
      return res;
    } catch (error) {
      console.error('API error: ', error);
      if ( isMount ) {
        setIsAPI48399Loading(false);
      }
      return false as unknown as API48399Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48399Loading,
    dataAPI48399,
    fetchAPI48399Data,
  }
}

